<template>
  <v-navigation-drawer
    v-model="show"
    right
    temporary
    fixed
    :width="navWidth"
    app
    class="nd-projects scrollable-drawer"
    style="display: flex; flex-direction: column; height: 100vh"
    @input="onDrawerToggle"
  >
    <div
      class="pa-4 scrollable-content"
      style="
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        height: 100%;
      "
      ref="scrollContent"
    >
      <v-card-title class="text-h4 d-flex align-center justify-center mb-4">
        <div>
          {{ truncatedProjectTitle }}
        </div>
        <v-spacer></v-spacer>
        <v-btn icon medium @click="close" style="border: 1px solid #000">
          <v-icon medium color="#000">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text style="flex: 1">
        <v-overlay :value="loading" absolute>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-overlay>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="projectx.name"
                label="Nombre del proyecto"
                placeholder="Nombre del proyecto"
                :rules="[(v) => !!v || 'El nombre del proyecto es requerido']"
                outlined
                prepend-inner-icon="mdi-file-document-edit-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <vuetify-money
                v-model="projectx.budget"
                label="Presupuesto"
                placeholder="Presupuesto"
                valueWhenIsEmpty=""
                v-bind:options="options"
                outlined
                :rules="[
                  (v) => !!v || 'El presupuesto del proyecto es requerido',
                ]"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="projectx.address"
                label="Dirección"
                placeholder="Dirección"
                outlined
                prepend-inner-icon="mdi-map-marker"
                :rules="[
                  (v) => !!v || 'La dirección del proyecto es requerida',
                ]"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <!-- Campo de texto que dispara el calendario -->
              <v-text-field
                v-model="formattedStartDate"
                label="Fecha de inicio"
                prepend-inner-icon="mdi-calendar"
                outlined
                readonly
                :rules="[(v) => !!v || 'La fecha de inicio es requerida']"
                @click="modalStartDate = true"
              />

              <!-- Diálogo con calendario -->
              <v-dialog v-model="modalStartDate" persistent width="290px">
                <v-date-picker
                  v-model="selectedStartDate"
                  scrollable
                  locale="es"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="dark" @click="modalStartDate = false">
                    Cancelar
                  </v-btn>
                  <v-btn text color="dark" @click="confirmStartDate">
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-row>
              <v-col cols="12">
                <v-divider class="my-4"></v-divider>
              </v-col>
              <v-col cols="12" md="12">
                <div class="col-12" style="font-size: 1.2em; font-weight: bold">
                  Tipo de construcción que realizas
                </div>
                <v-chip-group
                  v-model="projectx.type_id"
                  column
                  class="d-flex flex-wrap"
                  active-class="chip--active"
                  :rules="[(v) => !!v || 'Seleccioná un tipo de construcción']"
                >
                  <v-chip
                    v-for="tipo in types"
                    :key="tipo.id"
                    class="ma-2"
                    outlined
                    color="primary"
                    :value="tipo.id"
                    medium
                    filter
                  >
                    {{ tipo.name }}
                  </v-chip>
                </v-chip-group>
              </v-col>
              <v-col cols="12">
                <v-divider class="my-4"></v-divider>
              </v-col>
              <v-col cols="12" md="12">
                <div class="col-12" style="font-size: 1.2em; font-weight: bold">
                  Fase actual de tu proyecto
                </div>
                <v-chip-group
                  v-model="projectx.phase_id"
                  column
                  class="d-flex flex-wrap"
                  active-class="chip--active"
                  :rules="[(v) => !!v || 'Seleccioná una fase']"
                >
                  <v-chip
                    v-for="tipo in phases"
                    :key="tipo.id"
                    class="ma-2"
                    outlined
                    color="primary"
                    :value="tipo.id"
                    medium
                    filter
                  >
                    {{ tipo.name }}
                  </v-chip>
                </v-chip-group>
                <div v-if="selectedTipo" class="text-subtitle-1">
                  Me dedico a <strong>{{ selectedTipo.name }}</strong>
                </div>
              </v-col>
              <v-col cols="12">
                <v-divider class="my-4"></v-divider>
              </v-col>
            </v-row>
          </v-row>
        </v-form>

        <!-- Botón fijo -->
        <div class="mt-5 project-form-buttons">
          <v-btn
            block
            outlined
            :class="{
              'btn-disabled': !isFormComplete || loading,
              'btn-enabled': isFormComplete && !loading,
            }"
            @click="handleSubmit"
            :disabled="!isFormComplete || loading"
          >
            <transition name="fade-text" mode="out-in">
              <span :key="buttonText">{{ buttonText }}</span>
            </transition>
          </v-btn>
        </div>
      </v-card-text>
    </div>
  </v-navigation-drawer>
</template>
<script>
import ProjectService from "@/services/ProjectService";
import options from "@/config/money";
import { phases as phasesAll, types } from "@/config/projects/data";

export default {
  props: {
    visible: { type: Boolean, required: true },
    project: {
      type: Object,
      default: () => ({
        id: null,
        name: "",
        budget: 0,
        address: null,
        start_date: "",
        type_id: null,
        phase_id: null,
      }),
    },
  },

  data() {
    return {
      projectx: { ...this.project },
      show: this.visible,
      modalStartDate: false,
      valid: false,
      loading: false,
      phasesAll, // sync with DB
      types, // sync with DB
      selectedTipo: null,
      scrolledOnce: false,
      selectedStartDate: null,
    };
  },

  methods: {
    openDateDialog() {
      if (!this.modalStartDate) {
        this.modalStartDate = true;
      }
    },

    async handleSubmit() {
      this.loading = true;

      try {
        let response = null;

        const payload = {
          ...this.projectx,
          start_date: this.projectx.start_date,
        };

        if (this.newProject) {
          response = await ProjectService.createProject(payload);
        } else {
          response = await ProjectService.updateProject(
            this.project.id,
            payload
          );
        }

        if (response.ok) {
          this.loading = false;
          const result = await response.json();
          this.$emit("projectUpdated", result.project);
          this.close();
        }
      } catch (error) {
        console.error("Error al actualizar el proyecto");
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.$refs.form?.resetValidation();
      this.resetForm();
      this.$emit("close");
    },

    resetForm() {
      this.projectx = {
        id: null,
        name: "",
        budget: 0,
        address: "",
        start_date: "",
        type_id: null,
        phase_id: null,
      };
      this.selectedStartDate = null;
      this.valid = false;
      this.modalStartDate = false;
    },

    confirmStartDate() {
      this.projectx.start_date = this.selectedStartDate;
      this.modalStartDate = false;
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.scrollContent;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },

    onDrawerToggle(val) {
      if (!val) this.close();
    },
  },

  watch: {
    visible(value) {
      this.show = value;

      if (value) {
        this.$nextTick(() => {
          setTimeout(() => {
            const el = this.$refs.scrollContent;
            if (el) el.scrollTop = 0;
          }, 100);
        });
      }

      if (!value) this.resetForm();
    },
    project: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal || Object.keys(newVal).length === 0) {
          this.resetForm();
        } else {
          this.projectx = {
            id: newVal.id ?? null,
            name: newVal.name ?? "",
            budget: newVal.budget ?? 0,
            address: newVal.address ?? "",
            start_date: newVal.start_date ?? "",
            type_id: newVal.type_id ?? null,
            phase_id: newVal.phase_id ?? null,
          };

          this.selectedStartDate = newVal.start_date ?? null;
        }
      },
    },

    isFormComplete(newVal, oldVal) {
      if (newVal && !oldVal) {
        if (this.newProject) {
          this.$nextTick(() => {
            setTimeout(() => {
              const el = this.$refs.scrollContent;
              if (el) el.scrollTop = el.scrollHeight;
            }, 100);
          });
        }
      }
    },
  },

  computed: {
    options: () => {
      return options;
    },

    title() {
      return !this.newProject ? "Editar proyecto" : "Nuevo proyecto";
    },

    newProject() {
      return !(this.projectx && this.projectx.id);
    },

    isFormComplete() {
      const { name, budget, address, start_date } = this.projectx;
      return (
        !!name && !!budget && !!address && !!start_date && !this.modalStartDate
      );
    },

    buttonText() {
      if (!this.isFormComplete) return "Completá todos los campos";
      return this.projectx.id ? "Actualizar" : "Guardar";
    },

    navWidth() {
      return this.$vuetify.breakpoint.mdAndDown ? "100%" : "40%";
    },

    phases() {
      return this.newProject
        ? this.phasesAll.filter(
            (phase) => phase.name.toLowerCase() !== "finalizado"
          )
        : this.phasesAll;
    },

    truncatedProjectTitle() {
      const title = this.projectx.name || this.title;
      return this.$vuetify.breakpoint.smAndDown && title.length > 16
        ? title.substring(0, 16) + "…"
        : title;
    },
    formattedStartDate: {
      get() {
        if (!this.projectx.start_date) return "";
        const [y, m, d] = this.projectx.start_date.split("-");
        return `${d}/${m}/${y}`;
      },
      set(val) {
        const parts = val.split("/");
        if (parts.length === 3) {
          const [d, m, y] = parts;

          this.projectx.start_date = `${y}-${m}-${d}`;
        } else {
          this.projectx.start_date = null;
        }
      },
    },
  },
};
</script>
<style scoped>
.v-card-title {
  font-weight: bold;
}

.v-dialog__content.v-dialog__content--active {
  /* background: #fff; */
}

.chip--active {
  background-color: red !important; /* un azul más fuerte que el outlined */
  color: white !important;
  border-color: transparent !important;
}

.btn-disabled {
  background-color: #f2f2f2 !important;
  color: #999 !important;
  border-color: #ddd !important;
  cursor: not-allowed !important;
}

.btn-enabled {
  background-color: #1d1d1f !important;
  color: white !important;
  border-color: #1d1d1f !important;
}

.fade-text-enter-active,
.fade-text-leave-active {
  transition: opacity 0.5s ease;
}
.fade-text-enter,
.fade-text-leave-to {
  opacity: 0;
}

.responsive-dialog-content {
  border-radius: 12px;
  overflow: hidden;
  padding: 0;
}

@media (max-width: 960px) {
  .responsive-dialog-content {
    border-radius: 0 !important;
    margin: 0 !important;
  }

  .responsive-dialog-content.v-dialog--active {
    margin: 0 !important;
  }

  .project-form-buttons {
    padding-bottom: 20% !important;
  }
}

@media (min-width: 998px) {
  .nd-projects {
    /* padding: 2em; */
  }
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  background-color: white;
  padding-top: 8px;
  padding-bottom: 16px;
  z-index: 10;
}

.scrollable-content {
  overflow-y: auto;
  scroll-behavior: smooth;
  flex: 1;
}
</style>
